import React from 'react'

type Props = {
  className?: string
  fillColor?: string
  size?: number
}

// Outlined question-circle (FA5 Regular shape — circle outline + question
// mark glyph). Drawn as stroked paths so it renders as a true line icon
// rather than a filled silhouette. `size` matches the pattern in
// components/Icons/Copy.tsx so future icons can converge on a single
// sizing convention.
const QuestionCircleOutline = ({
  className,
  fillColor = 'currentColor',
  size = 16,
}: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    fill="none"
    stroke={fillColor}
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.7.4-1 1-1 1.7v.5" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
)

export default QuestionCircleOutline
